import { FC, ReactNode } from 'react'
import { Tooltip } from 'antd'
import { ExclamationCircleOutlined, CheckCircleOutlined } from '@ant-design/icons'

interface TableWarningIndicatorProps {
    status?: 'error' | 'success'
    tooltip?: ReactNode
    color?: string
    size?: number
}

const TableWarningIndicator: FC<TableWarningIndicatorProps> = ({
    status,
    tooltip,
    color,
    size = 16,
}) => {
    if (!status) return null

    const defaultColor = status === 'error' ? '#ff4d4f' : '#52c41a'
    const iconColor = color ?? defaultColor
    const IconComponent = status === 'error' ? ExclamationCircleOutlined : CheckCircleOutlined
    const defaultTooltip =
        status === 'error'
            ? 'Обнаружены ошибки валидации'
            : 'Все проверки пройдены'

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100%',
            }}
        >
            <Tooltip title={tooltip ?? defaultTooltip}>
                <IconComponent style={{ color: iconColor, fontSize: size }} />
            </Tooltip>
        </div>
    )
}

export default TableWarningIndicator
